import React from "react";
import { MapPin } from "lucide-react";
import { Label } from "../ui/label";
import { Input } from "../ui/input";

export function AddressForm({ userData, handleUserDataChange, errors }) {
  return (
    <div className="mb-6 md:mb-10">
      <div className="flex items-center gap-3 mb-4 md:mb-6">
        <div className="w-7 h-7 sm:w-9 sm:h-9 md:w-10 md:h-10 rounded-lg bg-gradient-to-br from-blue-800 to-blue-600 flex items-center justify-center shadow-md shrink-0">
          <MapPin className="w-4 h-4 sm:w-5 sm:h-5 text-white" />
        </div>

        <h2 className="text-lg sm:text-xl md:text-2xl font-semibold text-foreground">Endereço</h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-6">
        <div className="md:col-span-2">
          <Label htmlFor="logradouro" className="text-sm font-medium text-foreground">
            Logradouro <span className="text-red-500">*</span>
          </Label>

          <Input
            id="logradouro"
            value={userData.logradouro}
            onChange={(e) => handleUserDataChange("logradouro", e.target.value)}
            required
            className={`mt-2 border-2 transition-colors h-11 focus:ring-2 focus:ring-blue-800/20 ${
              errors.logradouro
                ? "border-red-400 focus:border-red-600"
                : "border-border focus:border-blue-800"
            }`}
          />

          {errors.logradouro && (
            <p className="mt-1 text-xs text-red-600">{errors.logradouro}</p>
          )}
        </div>

        <div>
          <Label htmlFor="numero" className="text-sm font-medium text-foreground">
            Número <span className="text-red-500">*</span>
          </Label>

          <Input
            id="numero"
            value={userData.numero}
            onChange={(e) => handleUserDataChange("numero", e.target.value)}
            required
            className={`mt-2 border-2 transition-colors h-11 focus:ring-2 focus:ring-blue-800/20 ${
              errors.numero
                ? "border-red-400 focus:border-red-600"
                : "border-border focus:border-blue-800"
            }`}
          />

          {errors.numero && (
            <p className="mt-1 text-xs text-red-600">{errors.numero}</p>
          )}
        </div>

        <div>
          <Label htmlFor="bairro" className="text-sm font-medium text-foreground">
            Bairro <span className="text-red-500">*</span>
          </Label>

          <Input
            id="bairro"
            value={userData.bairro}
            onChange={(e) => handleUserDataChange("bairro", e.target.value)}
            required
            className={`mt-2 border-2 transition-colors h-11 focus:ring-2 focus:ring-blue-800/20 ${
              errors.bairro
                ? "border-red-400 focus:border-red-600"
                : "border-border focus:border-blue-800"
            }`}
          />

          {errors.bairro && (
            <p className="mt-1 text-xs text-red-600">{errors.bairro}</p>
          )}
        </div>

        <div>
          <Label htmlFor="complemento" className="text-sm font-medium text-foreground">
            Complemento
          </Label>

          <Input
            id="complemento"
            value={userData.complemento}
            onChange={(e) => handleUserDataChange("complemento", e.target.value)}
            className="mt-2 border-2 border-border focus:border-blue-800 transition-colors h-11 focus:ring-2 focus:ring-blue-800/20"
          />
        </div>

        <div>
          <Label htmlFor="cep" className="text-sm font-medium text-foreground">
            CEP <span className="text-red-500">*</span>
          </Label>

          <Input
            id="cep"
            value={userData.cep}
            onChange={(e) => handleUserDataChange("cep", e.target.value)}
            required
            className={`mt-2 border-2 transition-colors h-11 focus:ring-2 focus:ring-blue-800/20 ${
              errors.cep
                ? "border-red-400 focus:border-red-600"
                : "border-border focus:border-blue-800"
            }`}
          />

          {errors.cep && <p className="mt-1 text-xs text-red-600">{errors.cep}</p>}
        </div>

        <div>
          <Label htmlFor="cidade" className="text-sm font-medium text-foreground">
            Cidade <span className="text-red-500">*</span>
          </Label>

          <Input
            id="cidade"
            value={userData.cidade}
            onChange={(e) => handleUserDataChange("cidade", e.target.value)}
            required
            className={`mt-2 border-2 transition-colors h-11 focus:ring-2 focus:ring-blue-800/20 ${
              errors.cidade
                ? "border-red-400 focus:border-red-600"
                : "border-border focus:border-blue-800"
            }`}
          />

          {errors.cidade && (
            <p className="mt-1 text-xs text-red-600">{errors.cidade}</p>
          )}
        </div>

        <div>
          <Label htmlFor="estado" className="text-sm font-medium text-foreground">
            Estado <span className="text-red-500">*</span>
          </Label>

          <Input
            id="estado"
            value={userData.estado}
            onChange={(e) =>
              handleUserDataChange(
                "estado",
                (e.target.value || "").toUpperCase().slice(0, 2)
              )
            }
            required
            className={`mt-2 border-2 transition-colors h-11 focus:ring-2 focus:ring-blue-800/20 ${
              errors.estado
                ? "border-red-400 focus:border-red-600"
                : "border-border focus:border-blue-800"
            }`}
          />

          {errors.estado && (
            <p className="mt-1 text-xs text-red-600">{errors.estado}</p>
          )}
        </div>
      </div>
    </div>
  );
}
